/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import React, { useRef } from "react";
import { HoverCard, HoverCardType, ThemeProvider, Text, Link } from "@fluentui/react";
import ReceivedFileIcon from "../../Compare/components/Icons/ReceivedFileIcon";
import SentFileIcon from "../../Compare/components/Icons/SentFileIcon";
import PdfIcon from "../../Compare/components/Icons/PdfIcon";


const onCardHide = () => {};

const styles = {
  Others: {
    fontSize: "14px",
    borderRadius: "8px",
    minWidth: "1px",
    maxWidth: "fit-content",
    color: "rgb(6 42 108)",
    cursor: "pointer",
    fontWeight: 500,
  },
  sentToList: {
    marginTop: "1%",
    display: "inline-block",
    height: "100%",
    width: "90%",
  },
  firstEmailInCard: {
    textDecorationLine: "underline",
    fontWeight: 500,
    color: "#18468F",
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Poppins",
  },
  card: {
    width: "100%",
    height: "max-content",
    padding: "15px",
    bottom: "70%",
  },
  sharedBy: {
    width: "100%",
    height: "18px",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    fontFamily: "Poppins",
  },
  sharedToStack: {
    gap: "2%",
    justifyContent: "flex-start",
    width: "100%",
    paddingTop: "2px",
    alignItems: "center",
  },
  sharedTo: {
    alignSelf: "flex-end",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    fontFamily: "Poppins",
    color: "#1F2430",
    width: "fit-content",
  },

  sharedToList: {
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    fontFamily: "Poppins",
    color: "#1F2430",
    width: "100%",
  },
};

const notesStyles = {
  fontWeight: 400,
  fontSize: "12px",
  fontFamily: "Poppins",
  color: "#51596C",
  lineHeight: "18px",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const FileIconHoverCard = (props) => {
  const hoverCard = useRef(null);

  const openTemplate = () => {
    Office.context.document.getFilePropertiesAsync(async (context) => {
      const messageToShareDialog = JSON.stringify({
        projectName: props.projectName,
        sharedByName: props.sharedBy,
        sharedByEmail: props.sharedBy?.email,
        sharedTo: props.sharedTo,
        notes: props.notes,
        fileType: props.fileType,
        receivedList: props.receivedList,
        subject: props.subject,
        url: props.url,
      });
      Office.context.ui.displayDialogAsync(
        `${process.env.BASE_URL}/EmailTemplate.html`,
        {
          width: 55,
          height: 65,
          displayInIframe: true,
        },
        (result) => {
          var dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            var message = JSON.parse(arg.message);
            if (message.type === "IAmReady") {
              dialog.messageChild(messageToShareDialog);
            }
            if (message.type === "close") {
              dialog.close();
            }
          });
        }
      );
    });
  };

  const onRenderPlainCard = () => {
    return (
      <div style={styles.card}>
        <div
          style={{
            marginBottom: "8px",
            width: "90%",
            gap: "4px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
            <Text
              style={{
                fontSize: "12px",
                lineHeight: "18px",
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#323232",
              }}
            >
              Subject: {props.subject}
            </Text>
          </div>
          <div style={{ ...notesStyles, WebkitLineClamp: 2 }}>{props.notes}</div>
          <Link
            style={{ fontSize: "12px", fontFamily: "Poppins", lineHeight: "18px", fontWeight: 400 }}
            onClick={openTemplate}
          >
            Read More
          </Link>
        </div>
      </div>
    );
  };
  const plainCardProps = {
    onRenderPlainCard,
  };

  return (
    <>
      {props.fileType === "received" && (
        <ThemeProvider>
          <HoverCard
            type={HoverCardType.plain}
            plainCardProps={plainCardProps}
            componentRef={hoverCard}
            onCardHide={onCardHide}
            style={{ borderRadius: "8px", width: "328px" }}
          >
            <div style={{ backgroundColor: "#F3F5F9", marginTop: "5px" }}>
              {props.isPdf ? <PdfIcon /> : <ReceivedFileIcon />}
            </div>
          </HoverCard>
        </ThemeProvider>
      )}

      {props.fileType === "sent" && (
        <ThemeProvider>
          <HoverCard
            type={HoverCardType.plain}
            plainCardProps={plainCardProps}
            componentRef={hoverCard}
            onCardHide={onCardHide}
            style={{ borderRadius: "8px", width: "328px" }}
          >
            <div style={{ backgroundColor: "#F3F5F9", marginTop: "5px" }}>
              {props.isPdf ? <PdfIcon /> : <SentFileIcon />}
            </div>
          </HoverCard>
        </ThemeProvider>
      )}
    </>
  );
};

export default FileIconHoverCard;
